import { useMutation } from "@tanstack/react-query";
import { AxiosResponseAndError } from "../types/axiosResponseType";
import { requestURLs } from "../../Environment";
import ApiRequest from "../ApiRequest";

export const useLinkClickMutaion = () => {
  return useMutation<
    AxiosResponseAndError<null>["response"],
    AxiosResponseAndError<null>["error"],
    {url:string}
  >({
    mutationFn: (url) =>
        ApiRequest.put(requestURLs.setLinkClick, {url}),
  });
};
